export function resolveAdminRedirect(isAdmin, mainRouteName) {
  if (isAdmin) return null

  return { name: mainRouteName }
}
